// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropdown-cart .media .media-aside[data-v-7a505611] {\n  align-items: center;\n}", ""]);
// Exports
module.exports = exports;
